module.exports = __webpack_public_path__ + "static/media/status3.bb83868f.png";